/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var MainMenuType;
    (function (MainMenuType) {
        MainMenuType["Mega"] = "mega";
        MainMenuType["Dropdown"] = "dropdown";
        MainMenuType["Sidebar"] = "sidebar";
        MainMenuType["Empty"] = "";
    })(MainMenuType || (MainMenuType = {}));
    var MainMenu = /** @class */ (function () {
        function MainMenu(type) {
            this.mainMenuElement = document.getElementById('mainmenu');
            this.type = type;
        }
        MainMenu.init = function () {
            if (document.body.classList.contains('has-mega-menu')) {
                return new MainMenu(MainMenuType.Mega).run();
            }
            else if (document.body.classList.contains('has-dropdown-menu')) {
                return new MainMenu(MainMenuType.Dropdown).run();
            }
            else if (document.body.classList.contains('has-sidebar-menu')) {
                return new MainMenu(MainMenuType.Sidebar).run();
            }
            return new MainMenu(MainMenuType.Empty);
        };
        MainMenu.prototype.run = function () {
            if (!this.mainMenuElement) {
                return;
            }
            if (this.isLargeBody()) {
                if (this.type === MainMenuType.Dropdown) {
                    this.fixLevel1();
                }
                else if (this.type === MainMenuType.Mega) {
                    this.wrapMegaMenu();
                }
            }
            if (this.type === MainMenuType.Sidebar) {
                this.sidebarMenu();
                return;
            }
            this.initClicks();
            this.sidebarMenu();
            window.addEventListener('DOMContentLoaded', function () {
                MoyaEventHandler.dispatch('mainmenu.init', {});
            });
        };
        MainMenu.prototype.isLargeBody = function () {
            return this.getBodyWidth() + 15 >= 992;
        };
        MainMenu.prototype.getBodyWidth = function () {
            return document.body.offsetWidth;
        };
        MainMenu.prototype.fixLevel1 = function () {
            var uls = this.mainMenuElement.querySelectorAll('.level1.children > ul');
            uls.forEach(function (ul) {
                if (!(ul instanceof HTMLUListElement) || !(ul.parentNode instanceof HTMLElement)) {
                    return;
                }
                var maxHeight = ul.scrollHeight + 80;
                var left = (ul.parentNode.offsetWidth / 2) - (ul.offsetWidth / 2);
                ul.style.left = left + 'px';
                ul.style.maxHeight = maxHeight + 'px';
            });
        };
        MainMenu.prototype.handleClick = function (e) {
            var link = e.delegateTarget;
            if (!(link instanceof HTMLAnchorElement) || !(link.parentNode instanceof HTMLElement)) {
                return;
            }
            var parent = link.parentNode;
            if (!parent.classList.contains('level1')) {
                return;
            }
            if (!this.isLargeBody()) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            var isOpen = parent.classList.contains('open');
            document.body.classList.remove('search-open');
            if (e.type === 'mouseover') {
                this.closeAll(parent);
            }
            else {
                this.closeAll();
            }
            if (!isOpen) {
                parent.classList.add('open');
                document.body.classList.add('mainmenu-open');
            }
        };
        MainMenu.prototype.initClicks = function () {
            var _this = this;
            util.delegate(this.mainMenuElement, 'click', '.level1.children a', function (e) { return _this.handleClick(e); });
            if (document.body.classList.contains('menu-has-mouseover')) {
                util.delegate(this.mainMenuElement, 'mouseover', '.level1.children a', function (e) { return _this.handleClick(e); });
            }
            document.body.addEventListener('click', function () {
                if (document.body.classList.contains('mainmenu-open')) {
                    _this.closeAll();
                }
            });
            if (this.isLargeBody() && this.type === MainMenuType.Mega) {
                var mega = document.querySelector('.megamenu');
                if (mega) {
                    mega.addEventListener('click', function (e) {
                        e.stopPropagation();
                    });
                }
            }
        };
        MainMenu.prototype.closeAll = function (skippedElement) {
            this.mainMenuElement.querySelectorAll('.level1.children').forEach(function (el) {
                if (!(el instanceof HTMLElement)) {
                    return;
                }
                if (!skippedElement) {
                    el.classList.remove('open');
                    return;
                }
                if (skippedElement && el !== skippedElement) {
                    el.classList.remove('open');
                }
            });
            document.body.classList.remove('mainmenu-open');
        };
        MainMenu.prototype.sidebarMenu = function () {
            var sidebarMenu = document.getElementById('sidebar');
            if (!sidebarMenu) {
                return;
            }
            sidebarMenu.querySelectorAll('.children > a').forEach(function (a) {
                var expandElement = document.createElement('a');
                expandElement.href = '#';
                expandElement.classList.add('expand');
                expandElement.addEventListener('click', function (evt) {
                    evt.preventDefault();
                    var closest = expandElement.closest('li');
                    if (closest) {
                        closest.classList.toggle('down');
                    }
                });
                a.insertAdjacentElement('afterend', expandElement);
            });
            sidebarMenu.querySelectorAll('.selectedLevel2, .selectedLevel3, .selectedLevel4').forEach(function (el) {
                el.classList.add('down');
            });
        };
        MainMenu.prototype.wrapMegaMenu = function () {
            var _this = this;
            var level2s = document.querySelectorAll('#mainmenu .mmLevel2');
            level2s.forEach(function (level2) {
                var contentWrap = document.createElement('div');
                contentWrap.classList.add('contentWrap');
                var wrap = document.createElement('div');
                wrap.classList.add('wrap');
                var megaMenu = document.createElement('div');
                megaMenu.classList.add('megamenu');
                _this.wrap(level2, megaMenu);
                _this.wrap(level2, wrap);
                _this.wrap(level2, contentWrap);
            });
        };
        MainMenu.prototype.wrap = function (el, wrapper) {
            el.parentNode.insertBefore(wrapper, el);
            wrapper.appendChild(el);
        };
        return MainMenu;
    }());

    MainMenu.init();

}());
typeof tsBuild === 'function' && tsBuild();})();
